import { createInfo } from '@liveauctioneers/hammer-ui-core/card/components/createInfo';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import ItemCardEstimate from '@/components/GridItemCard/Card/components/ItemCardEstimate/ItemCardEstimate';
import { ItemSummary } from '@/types/item/ItemSummary';

export const EstimateComponentSearchCard = createInfo<ItemSummary>({
    className: 'line-clamp-0',
    useText: ({ isLocked, isTimedPlusAuction, itemId }) => {
        if (isLocked || isTimedPlusAuction) {
            return null;
        }

        return (
            <div className="mt-3xs flex flex-col px-xs smMin:px-sm">
                <ItemCardEstimate
                    className={cn('text-xs smMin:text-sm')}
                    itemId={itemId}
                />
            </div>
        );
    },
});
